import React, { useState, useRef, useEffect } from "react";

const SearchableDrp = ({
  options = [],
  placeholder,
  value,
  onChange,
  icon = "🌍",
  searchable = true,
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const containerRef = useRef(null);

  const isOptionObject = (o) =>
    o && typeof o === "object" && ("value" in o || "label" in o);
  const getOptionValue = (o) => (isOptionObject(o) ? o.value : o);
  const getOptionLabel = (o) =>
    isOptionObject(o) ? (o.label ?? String(o.value)) : String(o);

  const normalizedOptions = Array.isArray(options) ? options : [];
  const filtered =
    searchable && search.trim()
      ? normalizedOptions.filter((o) =>
          getOptionLabel(o).toLowerCase().includes(search.trim().toLowerCase()),
        )
      : normalizedOptions;

  useEffect(() => {
    if (!isOpen) setSearch("");
  }, [isOpen]);

  useEffect(() => {
    if (disabled) setIsOpen(false);
  }, [disabled]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      return () =>
        document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [isOpen]);

  const displayValue = value ?? "";
  const selectedOption = normalizedOptions.find(
    (o) => getOptionValue(o) == displayValue,
  );
  const selectedLabel = selectedOption
    ? getOptionLabel(selectedOption)
    : displayValue
      ? String(displayValue)
      : "";

  return (
    <div
      ref={containerRef}
      className="dm-sans-100"
      style={{
        position: "relative",
        width: "100%",
        cursor: disabled ? "not-allowed" : undefined,
      }}
    >
      <div
        onClick={() => !disabled && setIsOpen((o) => !o)}
        style={{
          display: "flex",
          alignItems: "center",
          background: "rgba(0,0,0,0.04)",
          border: "1px solid rgba(0,0,0,0.1)",
          borderRadius: 8,
          padding: "10px 14px",
          cursor: disabled ? "not-allowed" : "pointer",
          minHeight: 42,
          opacity: disabled ? 0.85 : 1,
        }}
      >
        {/* <span style={{ marginRight: 10, fontSize: 16, opacity: 0.45, color: '#363636' }}>{icon}</span> */}
        <span
          style={{
            flex: 1,
            color: selectedLabel ? "#363636" : "#999999",
            fontSize: 14,
          }}
        >
          {selectedLabel || placeholder}
        </span>
        <span style={{ color: "#6b6b6b", fontSize: 12 }}>
          {isOpen ? "▲" : "▼"}
        </span>
      </div>

      {isOpen && !disabled && (
        <div
          style={{
            position: "absolute",
            left: 0,
            right: 0,
            top: "100%",
            marginTop: 4,
            background: "#ffffff",
            border: "1px solid rgba(0,0,0,0.08)",
            borderRadius: 8,
            boxShadow: "0 8px 24px rgba(0,0,0,0.1), 0 2px 8px rgba(0,0,0,0.06)",
            zIndex: 1000,
            overflow: "hidden",
            maxHeight: 280,
          }}
        >
          {searchable && (
            <div
              style={{ padding: 8, borderBottom: "1px solid rgba(0,0,0,0.08)" }}
            >
              <input
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search..."
                autoFocus
                style={{
                  width: "100%",
                  padding: "8px 12px",
                  background: "rgba(0,0,0,0.04)",
                  border: "1px solid rgba(0,0,0,0.1)",
                  borderRadius: 6,
                  color: "#363636",
                  fontSize: 14,
                  outline: "none",
                }}
              />
            </div>
          )}
          <div style={{ maxHeight: 220, overflowY: "auto", padding: 4 }}>
            {filtered.length === 0 ? (
              <div style={{ padding: 12, color: "#6b6b6b", fontSize: 13 }}>
                No matches
              </div>
            ) : (
              filtered.map((opt, index) => {
                const label = getOptionLabel(opt);
                const optValue = getOptionValue(opt);
                const isSelected = displayValue == optValue;
                const isHovered = hoveredIndex === index;
                return (
                  <div
                    key={isOptionObject(opt) ? optValue : `${label}-${index}`}
                    onClick={() => {
                      onChange(optValue);
                      setIsOpen(false);
                    }}
                    onMouseEnter={() => setHoveredIndex(index)}
                    onMouseLeave={() => setHoveredIndex(null)}
                    style={{
                      padding: "10px 12px",
                      cursor: "pointer",
                      borderRadius: 6,
                      background: isSelected
                        ? "rgba(255,75,79,0.12)"
                        : isHovered
                          ? "rgba(0,0,0,0.06)"
                          : "transparent",
                      color: isSelected
                        ? "#363636"
                        : isHovered
                          ? "#363636"
                          : "#5a5a5a",
                      fontSize: 14,
                      transition: "background 0.15s ease, color 0.15s ease",
                    }}
                  >
                    {label}
                  </div>
                );
              })
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchableDrp;
